import * as foundation from "../foundation"
import * as contextual from "../contextual"
import { createButton, createIconButton, createTextButton } from "./button"
import { createHeadingFontSizes, createHeadingLineHeights } from "./heading"
import {
  createTextFontSizes,
  createTextFontWeights,
  createTextLineHeights,
} from "./text"

export const button = createButton(foundation, contextual)
export const iconButton = createIconButton(foundation, contextual)
export const textButton = createTextButton(foundation, contextual)
export const headingFontSizes = createHeadingFontSizes(foundation, contextual)
export const headingLineHeights = createHeadingLineHeights(
  foundation,
  contextual,
)
export const textFontSizes = createTextFontSizes(foundation, contextual)
export const textFontWeights = createTextFontWeights(foundation, contextual)
export const textLineHeights = createTextLineHeights(foundation, contextual)
